<template>
	<div class="wrap">
		<!-- browser-suggestion -->
		<browser-suggestion></browser-suggestion>
		<!-- browser-suggestion -->

		<div class="wrapper">
			<!-- announcement-banner -->
			<banners class="announcement-banner"></banners>
			<!-- announcement-banner -->

			<!-- 最新公告 -->
			<div class="last-notice">
				<div class="card-panel">
					<div class="card-title">
						<div class="title">
							<a>招聘公告</a>
						</div>
					</div>
					<div class="card-body">
						<div
							class="card-item"
							v-for="(item, index) in currentPageData"
							:key="index"
							@click="link(item.oid, item.title)"
						>
							<p class="left">
								{{ item.title }}
							</p>
							<div class="date">
								{{ item.rlsdate }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- /最新公告 -->

			<!-- 分页 -->
			<pages
				v-if="globalPageParam.total > 0"
				:pageSize="globalPageParam.pageSize"
				:total="globalPageParam.total"
				:currentPage="globalPageParam.pageNo"
				:currentChange="pageCurrentChange"
				:sizeChange="pageSizeChange"
			></pages>
			<!-- /分页 -->
		</div>
	</div>
</template>

<script>
import banners from "../common/banner";
import pages from "../common/pages";
// import { announcData } from '../request/api';
// import { mapState } from 'vuex';
// import { mapMutations } from 'vuex';
import BrowserSuggestion from "../common/BrowserSuggestion";
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";

export default {
	components: {
		banners,
		pages,
		BrowserSuggestion,
	},
	name: "home",
	data() {
		return {
			// 全局返回路由
			globalBackRoute: {},
			SearchForm: {
				isIndex: false,
				rlstype: "",
				notice: "公告",
				nameLike: "",
			},
			list: [],
			select: "招聘公告",
			noticeName: "",
			options: [
				{
					value: "0",
					label: "招聘公告",
				},
				{
					value: "1",
					label: "招聘公示",
				},
				{
					value: "2",
					label: "校园招聘",
				},
				{
					value: "3",
					label: "社会招聘",
				},
				{
					value: "4",
					label: "内部招聘",
				},
			],
		};
	},
	computed: {
		...mapState([
			// 全局分页参数
			"globalPageParam",
			"globalPageData",
			"globalPageDataKey",
			"globalSearchFormData",
			// 分页是否恢复
			"globalPageDataRestore",
			// 全局分页参数
		]),
		...mapGetters(["getCurrGlobalPageDataKey"]),
		currentPageData() {
			if (!this.globalPageData[this.getCurrGlobalPageDataKey]) {
				return [];
			}
			return this.globalPageData[this.getCurrGlobalPageDataKey].data;
		},
	},
	mounted() {
		// this.initData()

		// 判断是否要恢复数据
		if (this.globalPageDataRestore) {
			// 消费数据
			this.putGlobalPageDataRestore(false);

			if (this.globalPageParam["requestType"] == "announc-data-api") {
				// 恢复字段
			} else {
				// 不是当前页面的数据
				// 正常初始化数据
				this.searchFromAction();
			}
		} else {
			// 正常初始化数据
			this.searchFromAction();
		}
	},
	methods: {
		...mapMutations([
			// 全局路由生产
			"pushBackRoute",
			// 分页action
			"putGlobalPageParam",
			"resetGlobalPageParam",
			"resetGlobalPageParamWithData",
			"putGlobalPageData",
			"resetGlobalPageData",
			"clearGlobalPageData",
			"setCurrGlobalPageDataKey",
			"resetCurrGlobalPageDataKey",
			"putGlobalSearchFormData",
			// 全局职业选择
			"setResumeSelectData",
			// 全局字典
			"putGlobalPageDataRestore",
		]),
		...mapActions([
			// 全局路由消费
			"popBackRoute",
			"globalPageRequest",
			"globalDictDataRequest",
		]),
		searchFromAction() {
			// 设置参数到全局中
			this.putGlobalSearchFormData(this.SearchForm);
			// 重置分页参数
			this.resetGlobalPageParam();
			// 请求后台搜索
			this.searchFromStore();
		},
		searchFromReset() {
			// 重置搜索表单
			this.$refs.SearchForm.resetFields();
		},
		searchFromStore() {
			// 从全局表单获取参数
			this.globalPageRequest({
				type: "announc-data-api",
				SearchForm: this.SearchForm,
			});
		},
		pageSizeChange(pageSize) {
			// 重置分页参数
			this.resetGlobalPageParam();
			// 设置
			this.putGlobalPageParam({
				pageSize,
			});
			// 搜索
			this.searchFromStore();
		},
		pageCurrentChange(pageNo) {
			this.putGlobalPageParam({
				pageNo,
			});
			//  现在时间
			let nowTime = new Date().getTime();
			// 判断是否从缓存中获取数据
			let cacheData = this.globalPageData[this.getCurrGlobalPageDataKey];
			if (
				cacheData &&
				cacheData.lastTime &&
				nowTime - cacheData.lastTime < 1000 * 60 * 5
			) {
				// 如果缓存中有数据， 显示缓存中的数据
				this.setCurrGlobalPageDataKey();
				return;
			}
			// 搜索
			this.searchFromStore();
		},
		initData() {
			//  获取数据
			// let data = {
			//   nameLike: this.noticeName,
			//   isIndex: false,
			//   rlstype: '',
			//   pageNo: this.offset,
			//   pageSize: this.limit,
			//   notice: '公告'
			// }
			// announcData(data).then(response => {
			//   // console.log(response)
			//   if(response.code == 1) {
			//       this.list = response.data
			//       try {
			//         this.total = response.message * 1;
			//       } catch (error) {
			//         console.error(error)
			//       }
			//   }
			// })
		},
		//搜索
		// search(){
		//   this.initData()
		// },
		link(oid, stitle) {
			//跳转
			this.$router.push(`/recruiList?id=${oid}&stitle=${stitle}`);
			// this.$router.push(`/recruiList?id=${oid}`);
		},
	},
};
</script>

<style lang="scss" scoped>
// width: auto;
.wrap {
	.wrapper {
		width: auto;
		margin: 0 auto;
		padding-left: 24px;
		padding-right: 24px;
		padding-top: 20px;
		padding-bottom: 20px;
	}

	// announcement-banner
	.announcement-banner {
		margin-bottom: 24px;
		height: 128px;

		::v-deep {
			.el-carousel .img-item {
				display: block;
				height: 128px;
				width: 100%;
			}

			.el-carousel__button {
				width: 12px;
			}

			.el-carousel .el-carousel__container {
				height: 128px;
			}
		}
	}

	// announcement-banner
}

// announcement-banner
.announcement-banner {
	margin-bottom: 12px;
}
// announcement-banner

// 最新公告
.last-notice {
	margin-bottom: 24px;

	.card-panel {
		// border-top-right-radius: 12px;
		// border-bottom-left-radius: 12px;
		// border-bottom-right-radius: 4px;
		// border-top-left-radius: 4px;
		padding: 12px;
	}

	.card-item {
		position: relative;
		display: flex;
		line-height: 32px;
		padding-left: 12px;
		padding-right: 12px;
		margin-bottom: 12px;
		// padding-top: 8px;
		// padding-bottom: 8px;
		cursor: pointer;
		justify-content: space-between;
		// border-bottom: 1px solid #eee;

		&::after {
			position: absolute;
			left: 0;
			right: 0;
			bottom: -6px;
			height: 1px;
			content: "";
			background: #ccc;
		}

		.left {
			flex: auto;
			margin-bottom: 0;

			white-space: normal;
			word-break: break-all;
			word-wrap: break-word;
			overflow-wrap: break-word;
		}

		.date {
			flex: 0 0 auto;
			margin-left: 12px;
		}

		&:last-child {
			border-bottom: none;

			&::after {
				display: none;
			}
		}
	}

	.card-item:hover {
		background: #0089d0;
		// background: linear-gradient(to right, #ffa39e, #4bc0eb);
		color: #fff;
		color: rgba(255, 255, 255, 0.8);
		// border-radius: 4px;
	}
}

// /最新公告

@media screen and (min-width: 320px) {
}

@media screen and (min-width: 480px) {
	.wrap {
		.wrapper {
		}

		// announcement-banner
		.announcement-banner {
			height: 154px;

			::v-deep {
				.el-carousel .img-item {
					display: block;
					height: 154px;
					width: 100%;
				}

				.el-carousel .el-carousel__container {
					height: 154px;
				}
			}
		}
		// announcement-banner
	}
}
/* 移动 */
@media screen and (min-width: 576px) {
}
/* 平板 */
@media screen and (min-width: 768px) {
	.wrap {
		// announcement-banner
		.announcement-banner {
			height: 204px;

			::v-deep {
				.el-carousel .img-item {
					display: block;
					height: 204px;
					width: 100%;
				}

				.el-carousel__button {
					width: 30px;
				}

				.el-carousel .el-carousel__container {
					height: 204px;
				}
			}
		}
		// announcement-banner
	}
}

/* PC */
@media screen and (min-width: 992px) {
	.wrap {
		// announcement-banner
		.announcement-banner {
			height: 260px;

			::v-deep {
				.el-carousel .img-item {
					display: block;
					height: 260px;
					width: 100%;
				}

				.el-carousel .el-carousel__container {
					height: 260px;
				}
			}
		}
		// announcement-banner
	}
}
@media screen and (min-width: 1200px) {
	.wrap {
		.wrapper {
			// width: 1200px;
			margin: 0 auto;
			padding-left: 0;
			padding-right: 0;
		}

		// announcement-banner
		.announcement-banner {
			height: 320px;

			::v-deep {
				.el-carousel .img-item {
					display: block;
					height: 320px;
					width: 100%;
				}

				.el-carousel .el-carousel__container {
					height: 320px;
				}
			}
		}
		// announcement-banner

		// last-notice
		.last-notice {
			width: 1200px;
			margin: 0 auto;
		}
	}
}
</style>
